<template>
  <!-- <div class="card" -->
    <div v-bind:class="{'card greenCard': makeGreen, 'card redCard': !makeGreen}">
        <apexchart
          id="chart"
          type="candlestick"
          :options="chartOptions"
          :series="series"
          class="minichart"
          align="center"
        ></apexchart>
    </div>
</template>
<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "PriceChartMini",
  components: {
    apexchart: VueApexCharts
  },
  props: ["ticker","height","width"],
  data() {
    return {
      chart_title: this.ticker,
      period: "1d",
      interval: "5m",
      data: null,
      series: [],
      chartOptions: {
        xaxis: {
          show: false,
          type: "datetime"
        },
        yaxis: {
          show: false
        },
        //   tooltip:false,
        chart: {
          toolbar: {
            show: false
          },
          height: this.height,
          width: this.width,
            zoom:{
                enabled:false,
            },
          background: "transparent",
        },
        title: {
            text: this.chart_title,
            align:"center",
           
        },
      },
      makeGreen: true,
    };
  },
  // computed: {},
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let params = {
        ticker: this.ticker,
        period: this.period,
        interval: this.interval
      };
      await axios
        .get(`${process.env.VUE_APP_DATA_API_HOST}/history`, {params:params})
        .then(response => {
          this.data = response.data;
          this.createSeries(this.data);
          this.updateColors(this.data);
        })
        .catch(e => {
          e;
        });
    },
    createSeries(data_in) {
      let data = data_in["data"];
      let newData = [];
      for (var key in data) {
        if (Object.hasOwn(data,key)) {
          newData.push({
            x: new Date(key),
            y: [
              data[key]["Open"],
              data[key]["High"],
              data[key]["Low"],
              data[key]["Close"]
            ]
          });
        }
      }
      this.series = [{ data: newData }];
      // this.chartOptions= {
      //   title: {
      //       text: this.ticker,
      //       align:"center",
      //       style:{
      //           weight:"bold"
      //       }
      //   }
      // }
    },
    updateColors(data_in) {
      let data = data_in["data"];
      let keys = Object.keys(data);
      let last = data[keys[keys.length-1]]["Close"]
      let first = data[keys[0]]["Close"]
      this.makeGreen = last > first ? true : false;

      this.chart_title = this.ticker + " (" + ((last - first) / first * 100).toFixed(2) + "%)"

      this.chartOptions= {
        title: {
            text: this.chart_title,
            align:"center",
            // fontWeight:"bold",
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              // fontFamily:  'Arial',
              // color:  '#263238'
            },
        }
      }
    }
  },
  watch: {
    ticker: function() {
      this.fetchData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card {
    /* Add shadows to create the "card" effect */
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      transition: 0.3s;
      border-radius: 5px;
    }

    .card.greenCard {
      background-color: rgba(186, 228, 186, 0.3) !important;
      
    }

    .card.redCard {
      background-color: rgba(228, 187, 186, 0.3) !important;
      
    }

    /* On mouse-over, add a deeper shadow */
    .card:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    /* Add some padding inside the card container */
    .container {
      padding: 2px 16px;
    }

    .apexcharts-title-text {
      font-weight: 600
    }
</style>
